import React from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";
import { logoutUser } from "../../../../actions/authActions";
import { userSelector } from "../../../../utils/selectors";

const AuthLinks: React.FC = () => {
  const intl = useIntl();
  const user = useSelector((state) => userSelector(state));
  const dispatch = useDispatch();
  const isCreatorFromProfileUpdate = useSelector((state: any) => state.profile?.profile?.user?.role?.includes("creator"));
  const location = useLocation();
  return (
    <Dropdown
      text={`${intl.formatMessage({
        id: "site.hello",
        defaultMessage: "Hello",
      })} ${user?.handle || user?.name || user?.email || ""}`}
    >
      <Dropdown.Menu>
        {user && user._id && (
          <Dropdown.Item
            icon="user"
            as={Link}
            to={`/profile/${user._id}`}
            text={intl.formatMessage({
              id: "nav.myProfile",
              defaultMessage: "My profile",
            })}
          />
        )}
        {(isCreatorFromProfileUpdate || user?.role?.includes("creator")) && (
          <Dropdown.Item
            icon="star"
            as={Link}
            to={{
              pathname: "/creator/dashboard",
            }}
            state={{
              from: location.pathname,
            }}
            text={intl.formatMessage({
              id: "nav.creatorPortal",
              defaultMessage: "Creator Portal",
            })}
          />
        )}
        <Dropdown.Item
          icon="history"
          as={Link}
          to="/purchase-history"
          text={intl.formatMessage({
            id: "nav.purchaseHistory",
            defaultMessage: "Purchase history",
          })}
        />

        <Dropdown.Item
          icon="sign-out"
          onClick={() => dispatch(logoutUser())}
          text={intl.formatMessage({
            id: "site.logout",
            defaultMessage: "Logout",
          })}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AuthLinks;
